import { render, staticRenderFns } from "./tree-org.vue?vue&type=template&id=423c2fd0&scoped=true&"
import script from "./tree-org.vue?vue&type=script&lang=js&"
export * from "./tree-org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c2fd0",
  null
  
)

export default component.exports